import React from 'react';
import styles from './AutocompleteInput.module.sass';
import { AsyncTypeahead, Typeahead } from "react-bootstrap-typeahead";
import api from "../../../../utils/api";

class AutocompleteInput extends React.Component {

  state = {
    hasFocus: false,
    value: '',
    valid: true,
    options: [],
    isLoading: false,
    optionsUpdated: false,
    defaultSelected: []
  };

  typeAhead = React.createRef();

  validate = (isOpen) => {
    if (isOpen) {
      return;
    }
    setTimeout(() => {
      if (this.props.value === "") {
        this.typeAhead.getInstance().clear();
        this.setState({ value: "" });
      }

      this.setState({
        hasFocus: false,
        valid: this.props.value !== "",
      });
    }, 0);
  };

  componentDidMount() {
    if (this.props.optionsUrl && (!this.props.async || this.props.readonly)) {
      api.get(this.props.optionsUrl).then((result) => {
        const formattedOptions = result.data.map(el => (this.props.formatter(el)));
        this.setState({
          options: formattedOptions,
          optionsUpdated: true
        });
      });
    }

    if (this.props.ibcValue && this.props.async) {
      this.onSearch(this.props.ibcValue);
    }
  }

  normalizedCompare(s1, s2) {
    const nS1 = s1.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    const nS2 = s2.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

    return nS1.toUpperCase() === nS2.toUpperCase();
  }

  normalizedIncludeCompare(s1, s2) {
    const nS1 = s1.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    const nS2 = s2.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

    return nS1.toUpperCase().includes(nS2.toUpperCase());
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.optionsUpdated === false && this.state.optionsUpdated === true) {
      this.setState({ isLoading: false, optionsUpdated: false });
      if (this.state.defaultSelected.length === 0 && this.props.ibcValue) {
        const selected = this.state.options.filter((el) => {
          return this.normalizedCompare(el.value.valor, this.props.ibcValue);
        });
        this.setState({
          defaultSelected: selected,
          value: selected.length > 0 && this.props.async ? selected[0].text : '',
        });
        if (this.props.hasOwnProperty('onSelect')) {
          this.props.onSelect(selected.length > 0 && selected[0].value);
        }
      }
    } else if (this.props.readonly && this.state.defaultSelected.length === 0) {
      this.setState({
        defaultSelected: this.findSelected(this.props.value),
      });
    }
  }

  findSelected = (selectedValue) => {
    const options = this.props.optionsUrl ? this.state.options : this.props.options;
    if (options.length === 0 && !this.props.readonly) {
      return [];
    }

    const selectedOption = options.filter((el) => (
      (el.value.hasOwnProperty('codigo') ? el.value.codigo : el.value) === selectedValue
    ));
    if (selectedOption.length === 0) {
      return [selectedValue];
    }
    return selectedOption;
  };

  onSearch = (value) => {
    const queryParams = {};
    queryParams[this.props.queryKey] = value;
    api.get(this.props.optionsUrl, null, queryParams).then((result) => {
      this.setState({ optionsUpdated: true, options: result.data.map(el => (this.props.formatter(el))) });
    });
    this.setState({ isLoading: true })
  };

  filterBy = (value) => {
    return Array.isArray(this.state.value) ? true : this.normalizedIncludeCompare(value.text, this.state.value);
  }

  updateChangeState = selected => {
    this.setState({
      valid: true,
    })
    if (selected.length > 0) {
      this.setState({
        value: selected
      });
    }
  }

  renderTypeahead = () => <Typeahead
  ref={(el) => this.typeAhead = el}
  onMenuToggle={this.validate}
  onFocus={() => this.setState({ hasFocus: true })}
  id='autocomplete'
  disabled={this.props.readonly}
  allowNew={this.props.readonly}
  inputProps={{
    className: styles.inputItem + (this.props.isValid === false || (this.props.isValid !== false && !this.state.valid) ? ' ' + styles.error : ''),
    value: this.state.value,
    valid: '' + !(this.props.isValid === false || (this.props.isValid !== false && !this.state.valid)),
    readOnly: this.props.readonly
  }}
  className={[styles.Typeahead, this.props.readonly ? styles.readOnly : ''].join(' ')}
  onChange={(selected) => {
    if (this.props.hasOwnProperty('onSelect')) {
      this.props.onSelect(selected.length > 0 ? selected[0].value : '');
    }
    this.updateChangeState(selected);
  }}
  onInputChange={(value) => {
    if (this.props.hasOwnProperty('onSelect')) {
      this.props.onSelect('');
    }
    this.setState({ value });
  }}
  options={this.props.optionsUrl ? this.state.options : this.props.options}
  selected={this.findSelected(this.props.value)}
  labelKey='text'
  emptyLabel='Sem resultados'
  filterBy={this.filterBy}
/>
renderAsyncTypeahead = () =>  <AsyncTypeahead
ref={(el) => this.typeAhead = el}
onSearch={this.onSearch}
isLoading={this.state.isLoading}
onBlur={this.validate}
onFocus={() => this.setState({ hasFocus: true })}
id='autocomplete'
minLength={2}
disabled={this.props.readonly}
allowNew={this.props.readonly}
inputProps={{
  className: styles.inputItem + (this.props.isValid === false || (this.props.isValid !== false && !this.state.valid) ? ' ' + styles.error : ''),
  valid: '' + !(this.props.isValid === false || (this.props.isValid !== false && !this.state.valid)),
  readOnly: this.props.readonly
}}
className={[styles.Typeahead, this.props.readonly ? styles.readOnly : ''].join(' ')}
onChange={(selected) => {
  if (this.props.hasOwnProperty('onSelect')) {
    this.props.onSelect(selected.length > 0 ? selected[0].value : '');
  }
  this.setState({
    value: selected,
    valid: true,
  })
}}
onInputChange={(value) => {
  if (this.props.hasOwnProperty('onSelect')) {
    this.props.onSelect('');
  }

  this.setState({ value });
}}
options={this.props.optionsUrl ? this.state.options : this.props.options}
selected={this.state.defaultSelected}
labelKey='text'
emptyLabel='Sem resultados'
promptText='Digite para pesquisar'
searchText='Buscando resultados'
/>
  render() {
    return (
      <fieldset className={[this.props.className, styles.InputContainer].join(' ')}>
        {this.props.async ? (
         this.renderAsyncTypeahead()
        ) : (
            this.renderTypeahead()
          )}
        {this.props.async ? null : <i className={"icon icon-seta-baixo-p"} />}
        <label
          className={[styles.floatLabel, this.state.hasFocus ||
            (this.state.value != null && this.state.value.length > 0) ||
            (this.props.value != null && this.props.value.length > 0)
            ? styles.focus : ''].join(' ')}>{this.props.typeDocument}</label>
        <span
          className={
            styles.errorMsg + (this.props.isValid === false || (this.props.isValid !== false && !this.state.valid) ? " " + styles.invalid : "")
          }
        >
          {'Ops! Este campo é obrigatório preencher.'}
        </span>
      </fieldset>
    )
  }
}


export default AutocompleteInput;
